<template lang="pug">
    mixin bannerButton(text, url=null)
        li
            if url
                span
                    a(href=url) #{text}
            else
                span= text

    .register-landing-outer-wrapper(:class="'context-'+context")
        include RegisterLanding.pug
</template>
<script>
import { mapState } from 'vuex';

export default {
    name: 'RegisterLanding',
    computed: mapState([
        "context",
    ]),
    data() {
        return {
            banner1Link: 'registro-de-profesionales',
            banner2Link: 'registro-de-escuelas',
            banner3Link: 'registro-de-instalaciones-de-ejercicio-fisico',
            banner1Text: "Prefesionaliza tu carrera, muestra tu profesionalismo y accede a contenido exclusivo de la industria.",
            banner2Text: "Consigue visibilidad en nuestro directorio y aumenta tus posibilidades de diferenciarte de las otras escuelas.",
            banner3Text: "Promociona y haz crecer tu negocio accediendo a diversas herramientas comerciales para cualquier tamaño o etapa.",
        };
    },
    created() {
        if (this.context == 'colreps') {
            this.banner1Link += "-2";
            this.banner2Link += "-2";
            this.banner3Link += "-2";
        }
    }
}
</script>

<style scoped lang="scss">
@import "./../../variables";
@import "./../../variables_colreps";
@import "./../../variables_mexreps";
@import "./RegisterLanding";

.context-colreps {
    @import "./RegisterLandingColreps";
}
.context-mexreps {
    @import "./RegisterLandingMexreps";
}
</style>



// WEBPACK FOOTER //
// src/components/register/RegisterLanding.vue